import { useWindowEvent }              from "@mantine/hooks";
import { useRouter }                   from "next/router";
import { useEffect, useRef, useState } from "react";

export const useReels = ( ) => {

	const [ currentIdx, setIdx ] = useState ( 0 );
	const router                 = useRouter ();
	const componentRefs          = useRef ( [] );

	useWindowEvent ( "keydown", e => {
		if ( e.key === "ArrowDown" ) {
			scrollToComponent ( currentIdx + 1 );
		}
		if ( e.key === "ArrowUp" ) {
			if ( currentIdx > 0 )
				scrollToComponent ( currentIdx - 1 );
		}
	} );

	useEffect ( () => {
		const options = {
			root       : null, // Use the viewport as the root
			rootMargin : "0px", // No margin around the viewport
			threshold  : 0.5 // Trigger when 50% of the component is in view
		};

		const handleIntersection = entries => {
			entries.forEach ( entry => {
				if ( entry.isIntersecting ) {
					  // Perform any actions when the component is in view
					const componentId = parseInt ( entry.target.id );

					const reelId = entry.target.dataset.reelid;

					if ( reelId !== "customid" ) {
						if ( router.query.user ) {
							router.replace ( `/reels/${ reelId }?user=${ router.query.user }`, undefined, { shallow: true } );
						} else {
							router.replace ( `/reels/${ reelId }`, undefined, { shallow: true } );
						}
						setIdx ( componentId );
					}
				} else {
					  // The component is out of view
				}
			} );
		};

		const observer = new IntersectionObserver ( handleIntersection, options );

		  // Observe each component
		componentRefs.current.forEach ( componentRef => {
			if ( componentRef ) {
				observer.observe ( componentRef );
			}
		} );

		  // Clean up the observer when the component unmounts
		return () => {
			observer.disconnect ();
		};
	}, [ componentRefs.current.length ] );

	const scrollToComponent =  componentIndex => {
		if ( componentRefs.current[componentIndex] ) {
			componentRefs.current[componentIndex].scrollIntoView ( {
				behavior : "smooth", // Add smooth scrolling animation
				block    : "start" // Scroll to the top of the component
			} );
		}
	};

	return { currentIdx, componentRefs, scrollToComponent };
};
